import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {RouteParams} from 'types/routes'
import {Index} from 'pages/withAuth/adminPage/settings/pat/index'

export const patRoutes: RouteParams[] = [
  {
    key: 'settings/pat',
    path: WITH_AUTH_ADMIN_PATHS.SETTINGS.PAT.INDEX,
    component: Index,
    exact: true,
    whiteList: ['full_admin'],
  },
]
